import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { ActivatedRoute, Router } from '@angular/router'
import { ToastrService } from 'ngx-toastr'
import { MemberService } from '../member.service'
import { ClientService } from '../../client/client.service'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MasterCommonServices } from '../../quotation/master.common.service'

@Component({
  selector: 'app-add-member',
  standalone: true,
  imports: [
    CommonModule,
    MatProgressBarModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: './add-member.component.html',
  styleUrl: './add-member.component.css',
})
export class AddMemberComponent implements OnInit {
  addMemberForm: FormGroup = new FormGroup({})
  isLoading: boolean = false
  submitted: boolean = false
  mode: string = 'add'
  memberData: any
  isSubmitDisabled: boolean = false

  constructor(
    private formBuilder: FormBuilder,
    private memberService: MemberService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    public masterCommonService: MasterCommonServices,
  ) {}

  ngOnInit(): void {
    this.initializeForm()
    this.route.queryParams.subscribe((params) => {
      this.mode = params['mode'] || 'add'
      this.memberData = params
      if (this.mode === 'update' || this.mode === 'view') {
        this.addMemberForm.patchValue({
          id: params['id'],
          clientId: params['clientId'],
          memberName: params['memberName'],
          email: params['email'],
          mobile: params['mobile'],
          isWhatsApp: params['isWhatsApp'] == 'true',
          skypeId: params['skypeId'],
          telephone: params['telephone'],
          addedOn: params['addedOn'],
          modifiedOn: params['modifiedOn'],
        })
        this.addMemberForm.markAsPristine()
        this.isSubmitDisabled = true
      }
    })

    this.masterCommonService.getAllClients()
    
    // Subscribe to form value changes to enable/disable submit button
    this.addMemberForm.statusChanges.subscribe(() => {
      this.updateSubmitButtonState()
    })
  }

  updateSubmitButtonState(): void {
    // Disable submit button if form is pristine (not modified)
    this.isSubmitDisabled = this.addMemberForm.pristine
  }

  initializeForm() {
    this.addMemberForm = this.formBuilder.group({
      id: [null],
      clientId: ['', Validators.required],
      memberName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      mobile: ['', Validators.required],
      isWhatsApp: [false],
      skypeId: [''],
      telephone: [''],
      addedOn: [''],
      modifiedOn: [''],
    })
  }

  submit() {
    this.submitted = true
    if (this.addMemberForm.invalid) {
      return
    }
    this.isLoading = true
    let payload = this.addMemberForm.value
    payload['modifiedOn'] = new Date(
      new Date().getTime() - new Date().getTimezoneOffset() * 60000,
    ).toISOString()
    if (this.mode === 'update') {
      this.memberService.updateMember(payload).subscribe({
        next: (response: any) => {
          this.isLoading = false
          this.toastr.success(
            'Member Updated Successfully!!',
            'Updation Successful',
          )
          this.masterCommonService.getAllMembers()
          // Mark form as pristine and disable submit button
          this.addMemberForm.markAsPristine()
          this.isSubmitDisabled = true
          this.submitted = false
        },
        error: (error: any) => {
          this.isLoading = false
          this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
        },
      })
    } else {
      payload['addedOn'] = new Date(
        new Date().getTime() - new Date().getTimezoneOffset() * 60000,
      ).toISOString()
      this.memberService.addMember(payload).subscribe({
        next: (response: any) => {
          this.isLoading = false
          this.masterCommonService.getAllMembers()
          this.toastr.success(
            'Member Added Successfully!!',
            'Creation Successful',
          )
          // Change mode to edit, populate ID, and disable submit button
          this.mode = 'update'
          this.addMemberForm.patchValue({
            id: response?.id,
            addedOn: response?.addedOn
          })
          this.addMemberForm.markAsPristine()
          this.isSubmitDisabled = true
          this.submitted = false
        },
        error: (error: any) => {
          this.isLoading = false
          this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
        },
      })
    }
  }
}
